<!--案例中心-->
<template>
  <div class="case-layer">
    <div class="box" v-for="item in caseList" :key="item.id" @click="jumpCase(item.url, item.id)"
         @mouseenter="item.active = true" @mouseleave="item.active = false">
      <div class="topimg">
        <img :src="!item.active ? item.imgsrc : item.activeimgsrc" />
      </div>
      <div class="title">{{ item.title }}</div>
      <div class="desc">{{ item.desc }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data () {
    return {
      caseList: [
        // { id: 1, url: '/case/caseselect', imgsrc: require('@imgs/case/Group_297.png'), activeimgsrc: require('@imgs/case/Group_300.png'), title: 'AI场景案例', desc: '通过体验实际使用场景，了解AI智能体的实际落地应用，并且通过案例的指引复现该过程', active: false },
        { id: 1, url: '/case/allscene', imgsrc: require('@imgs/case/Group_297.png'), activeimgsrc: require('@imgs/case/Group_300.png'), title: 'AI场景案例', desc: '通过体验实际使用场景，了解AI智能体的实际落地应用，并且通过案例的指引复现该过程', active: false },
        { id: 2, url: '/case/caseselect', imgsrc: require('@imgs/case/Group_299.png'), activeimgsrc: require('@imgs/case/Group_302.png'), title: '工作流训练案例', desc: '了解Dygpt工作流的功能及使用方式，并在案例的练习中，由浅到深完全掌握Dygpt', active: false },
        { id: 3, url: '/case/dygpt', imgsrc: require('@imgs/case/Group_301.png'), activeimgsrc: require('@imgs/case/Group_298.png'), title: 'DYGPT自由模式', desc: '请尽情自由探索Dygpt！搭建属于你自己的AI智能体', active: false },
      ]
    }
  },
  computed: {},
  watch: {},
  created () { },
  mounted () { },
  methods: {
    jumpCase (url, id) {
      // this.$router.push(url)
      // 将案例类型缓存起来
      sessionStorage.setItem('casetype', id)
      if (id != 3) {
        this.$router.push(url)
      } else {
        // let newurl = '/case/dygpt' + '?u=' + sessionStorage.getItem('dygptaccount') + '&p=' + sessionStorage.getItem('dygptpwd') + '&type=3'
        let newurl = '/case/dygpt' + '?u=' + sessionStorage.getItem('dygptaccount') + '&p=1234' + '&type=3'
        this.$router.push(newurl)
      }

    },

  }
}
</script>

<style scoped lang="less">
.case-layer {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .box {
    width: 2.5rem;
    height: 4rem;
    margin: 0 0.3rem;
    padding: 0.4rem 0.2rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    background-image: linear-gradient(to bottom, rgba(31, 150, 255, 0.3), rgba(0, 127, 63, 0.3));
    border-radius: 10px;
    cursor: pointer;
    color: #fff;
    text-shadow: 1px 1px 1px #000;
    transition: all 0.1s linear;
    backdrop-filter: blur(6px);
    box-shadow: 0 0 10px -5px rgba(205, 240, 255, 0.6) inset;

    .topimg {
      width: 1.2rem;
      height: 1.2rem;

      img {
        width: 100%;
        height: 100;
        display: block;
      }
    }

    .title {
      text-align: center;
      font-size: 22px;
      margin: 0.4rem 0;
      letter-spacing: 5px;
    }

    .desc {
      font-size: 14px;
      line-height: 1.5;
      text-indent: 2em;
      letter-spacing: 5px;
    }
  }

  .box:hover {
    scale: 1.04;

    .topimg {
      opacity: 0.9;
    }
  }

}
</style>
